export default __webpack_public_path__ + "assets/models/1fcde1e06d8221cec71678e0a7faf645.glb";